import React, { useMemo, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import "./eventmedia-form-page.css"; // minimal two-column layout

const API = "https://api.ainfotech.com.np";

export default function EventMediaForm({ initial, onSaved, onCancel }) {
  const editor = useRef(null);

  const [type, setType] = useState(initial?.type || "event");      // event | media
  const [title, setTitle] = useState(initial?.title || "");
  const [excerpt, setExcerpt] = useState(initial?.excerpt || "");
  const [status, setStatus] = useState(initial?.status || "draft"); // draft | published
  const [publishedAt, setPublishedAt] = useState(initial?.published_at?.slice?.(0, 10) || "");
  const [content, setContent] = useState(initial?.content_html || "");
  const [cover, setCover] = useState(null);
  const [saving, setSaving] = useState(false);

  const config = useMemo(() => ({
    readonly: false,
    height: 320,
    uploader: { insertImageAsBase64URI: true }
  }), []);

  const submit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("type", type);
    fd.append("title", title);
    fd.append("excerpt", excerpt);
    fd.append("status", status);
    if (publishedAt) fd.append("published_at", publishedAt);
    fd.append("content_html", content);
    if (cover) fd.append("cover_image", cover);

    try {
      setSaving(true);
      const url = initial?.id ? `${API}/api/eventmedia/${initial.id}` : `${API}/api/eventmedia`;
      const method = initial?.id ? "PUT" : "POST";
      const res = await fetch(url, { method, credentials: "include", body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Save failed");
      onSaved?.();
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="em-form-page minimalist">
      {/* LEFT: main content */}
      <section className="em-left">
        <div className="card">
          <label className="f">
            <span className="f__label">Title</span>
            <input className="f__input" value={title} onChange={e => setTitle(e.target.value)} required placeholder="Enter title" />
          </label>
        </div>

        <div className="card">
          <label className="f">
            <span className="f__label">Card Description (Excerpt)</span>
            <textarea className="f__textarea" rows="3" value={excerpt} onChange={e => setExcerpt(e.target.value)} placeholder="Short summary shown in cards…" />
          </label>
        </div>

        <div className="card">
          <div className="card__title">Cover Image</div>
          <input className="f__input" type="file" accept="image/*" onChange={e => setCover(e.target.files?.[0] || null)} />
        </div>

        <div className="card">
          <div className="card__title">Content</div>
          <div className="editor">
            <JoditEditor ref={editor} value={content} config={config} onChange={val => setContent(val)} />
          </div>
        </div>
      </section>

      {/* RIGHT: publish panel */}
      <aside className="em-right">
        <div className="card slim">
          <div className="card__title">Publish</div>

          <label className="f">
            <span className="f__label">Type</span>
            <select className="f__input" value={type} onChange={e => setType(e.target.value)}>
              <option value="event">event</option>
              <option value="media">media</option>
            </select>
          </label>

          <label className="f">
            <span className="f__label">Status</span>
            <select className="f__input" value={status} onChange={e => setStatus(e.target.value)}>
              <option value="draft">draft</option>
              <option value="published">published</option>
            </select>
          </label>

          <label className="f">
            <span className="f__label">Published Date</span>
            <input className="f__input" type="date" value={publishedAt} onChange={e => setPublishedAt(e.target.value)} />
          </label>

          <div className="row end gap">
            <button type="button" className="btn btn--sm" onClick={onCancel}>Cancel</button>
            <button disabled={saving} className="btn primary">{saving ? "Saving..." : (initial?.id ? "Update" : "Create")}</button>
          </div>
        </div>
      </aside>
    </form>
  );
}
